/*
 * op payment account
 *
 * Used to generate a javascript object from user input array of key - values
 * to another javascript object understandable by the api
 *
 * Copyright (c) 2017 "optile GmbH" Joseph El Alam
 */
'use strict';

/**
 * Normalizes string and removed allowed seperators
 *
 * @param {String} value
 * @return {String} nrmalized value
 */
function getNormalizedAccount(value) {
    return ('' + value)
        .replace(/\s+/g, '')
        .replace(/\./g, '')
        .replace(/-/g, '');
}

function getNormalizedInt(value) {
    return value.length > 0 ? value : null;
}

function trim(str) {
    return str ? str.replace(/^\s+|\s+$/gm, '') : str;
}

function createMergedObject(formData) {
    var mergedObject = {};
    for (var index = 0; index < formData.length; index++) {
        mergedObject[formData[index].name] = formData[index].value;
    }

    return mergedObject;
}

function normalizeValue(key, value) {
    var trimmedValue = trim(value);
    switch (key) {
        case 'number':
        case 'bankCode':
        case 'iban':
        case 'bic':
            return getNormalizedAccount(trimmedValue);
        case 'expiryMonth':
        case 'expiryYear':
            return getNormalizedInt(trimmedValue);
        case 'optIn':
            return true;
        default:
            return trimmedValue;
    }
}

function normalizeFields(formData) {
    var normalizedFormData = [];
    formData.map(function(aField) {
        normalizedFormData.push({
            name: aField.name,
            value: normalizeValue(aField.name, aField.value),
        });
    });

    return normalizedFormData;
}

function getNormalizedObject(formData) {
    var normalizedFormData = normalizeFields(formData);

    return createMergedObject(normalizedFormData);
}

/**
 * Creates an account object from array of name - value pairs of user input.
 * Use jQuery $("#form").serializeArray() to get form data in appropriate format.
 *
 * @param formData the user input data from account form.
 * @return the normalized account object.
 */
function fromForm(formData) {
    if (!formData || !formData.length) {
        return {};
    }

    return getNormalizedObject(formData);
}

module.exports = {
    fromForm: fromForm,
    getNormalizedAccount: getNormalizedAccount,
};
